export const FIRST_PENCIL_INTERCEPT_OPENED = 'FIRST_PENCIL_INTERCEPT_OPENED';
export const FIRST_PENCIL_SETUP_MODE_SELECTED = 'FIRST_PENCIL_SETUP_MODE_SELECTED';
export const FIRST_PENCIL_TEMPLATE_SELECTED = 'FIRST_PENCIL_TEMPLATE_SELECTED';
export const FIRST_PENCIL_VEHICLE_SELECTED = 'FIRST_PENCIL_VEHICLE_SELECTED';
export const FIRST_PENCIL_PROGRAM_SELECTED = 'FIRST_PENCIL_PROGRAM_SELECTED';
export const FIRST_PENCIL_CREATE_CONFIRMED = 'FIRST_PENCIL_CREATE_CONFIRMED';
export const FIRST_PENCIL_CANCELLED = 'FIRST_PENCIL_CANCELLED';
export const FIRST_PENCIL_PROGRAMS_BACK = 'FIRST_PENCIL_PROGRAMS_BACK';
export const FIRST_PENCIL_PROGRAMS_REQUEST = 'FIRST_PENCIL_PROGRAMS_REQUEST';
export const FIRST_PENCIL_PROGRAMS_SUCCESS = 'FIRST_PENCIL_PROGRAMS_SUCCESS';
export const FIRST_PENCIL_PROGRAMS_FAILURE = 'FIRST_PENCIL_PROGRAMS_FAILURE';
export const FIRST_PENCIL_PROGRAMS_LOAD_STARTED = 'FIRST_PENCIL_PROGRAMS_LOAD_STARTED';
export const FIRST_PENCIL_INCENTIVES_SELECTED = 'FIRST_PENCIL_INCENTIVES_SELECTED';
export const FIRST_PENCIL_INCENTIVE_OVERRIDDEN = 'FIRST_PENCIL_INCENTIVE_OVERRIDDEN';
export const FIRST_PENCIL_PROGRAM_CLEARED = 'FIRST_PENCIL_PROGRAM_CLEARED';
export const FIRST_PENCIL_OFFER_TYPE_SWITCHED = 'FIRST_PENCIL_OFFER_TYPE_SWITCHED';
export const FIRST_PENCIL_APPLY_SUCCEEDED = 'FIRST_PENCIL_APPLY_SUCCEEDED';
export const FIRST_PENCIL_APPLY_FAILED = 'FIRST_PENCIL_APPLY_FAILED';
export const FIRST_PENCIL_MANUAL_INCENTIVE_ADDED = 'FIRST_PENCIL_MANUAL_INCENTIVE_ADDED';
export const FIRST_PENCIL_MANUAL_INCENTIVE_UPDATED = 'FIRST_PENCIL_MANUAL_INCENTIVE_UPDATED';
